import { Spine } from "@esotericsoftware/spine-pixi-v8";
import type { SkeletonData } from "@esotericsoftware/spine-pixi-v8";
import { setClip } from "@slot/presentation";
import type { PresentationTaskRunner, SpineDriver } from "@slot/presentation";
import type { FountainCoin } from "./CoinFountainView";

/**
 * A fountain coin drawn by a Spine skeleton whose looping clip is the coin's spin. The shared `SpineDriver` ticks it
 * only while it flies; the clip plays at the runner's time scale times the coin's own rate, from a phase of its own,
 * so no two coins turn in step.
 */
export class SpineCoin implements FountainCoin {
  public readonly node: Spine;
  private readonly spinClip: string;
  private readonly spineDriver: SpineDriver;
  private readonly runner: PresentationTaskRunner;

  public constructor(input: { skeletonData: SkeletonData; spinClip: string; spineDriver: SpineDriver; runner: PresentationTaskRunner }) {
    this.node = new Spine({ skeletonData: input.skeletonData, autoUpdate: false });
    this.spinClip = input.spinClip;
    this.spineDriver = input.spineDriver;
    this.runner = input.runner;
  }

  public startSpin(rate: number, phase: number): void {
    this.spineDriver.attach(this.node);
    const entry = setClip(this.node, this.runner, this.spinClip, true);
    if (!entry) return;
    entry.timeScale = rate;
    entry.trackTime = phase * entry.animationEnd;
    this.node.update(0);
  }

  public stopSpin(): void {
    this.spineDriver.detach(this.node);
  }
}
